module.exports = __webpack_public_path__ + "static/img/son3.e0920778.png";